export default "__VITE_ASSET__C0LQ8NPr__"